export enum ProjectRanking {
  Primary = 'Primary',
  Secondary = 'Secondary',
}
